/* ===== DONATION CART VALIDATION: Selly + FBT "Add selected to cart" ===== */
/*
 * FILE: assets/donation-cart-validation.js
 * LOADED VIA: layout/theme.liquid — one <script defer> line before </body>
 *
 * PURPOSE:
 *   The normal Add to Cart button is protected by _addToCart_mg in theme.min.js,
 *   which calls /search?view=mg-cart-exist-vendor before adding any item.
 *   This blocks mixing Donation vendor items with normal items in the cart.
 *
 *   Two third-party app buttons bypass this check entirely:
 *     - Selly "Add selected to cart"       → button.tdf_normal_btn[data-e="bundle_add_all"]
 *     - FBT "Add selected to cart"         → button.cbb-frequently-bought-add-button
 *
 *   This file intercepts clicks on those two buttons and runs the same
 *   validation check before allowing the add to proceed.
 *
 * FILES THIS CODE DEPENDS ON (do not remove):
 *   - templates/search.mg-cart-exist-vendor.liquid  (validation endpoint)
 *   - theme.min.js _addToCart_mg                    (myModal already handled there)
 *
 * TO REMOVE THIS FILE:
 *   1. Delete assets/donation-cart-validation.js from theme Assets
 *   2. Remove the <script> line from layout/theme.liquid
 *   Nothing else needs to change.
 *
 * BUSINESS ASSUMPTION — read before changing FBT or Selly configuration:
 *   - Donation products are never configured as FBT recommendations.
 *   - FBT recommendations contain normal products only.
 *   - FBT never appears on Donation product pages.
 *   - Selly bundles are tied to the current product page.
 *   Therefore validating the current product handle is sufficient.
 *   We do not need to inspect the app payloads to know what is being added.
 *   If any of the above configurations change in future, this file must be
 *   revisited — the guard may no longer catch all conflict cases.
 */

(function () {

  var DONATION_APP_BUTTON_SELECTORS = [
    'button.tdf_normal_btn[data-e="bundle_add_all"]',
    'button.cbb-frequently-bought-add-button'
  ];

  function getDonationAppButton(target) {
    if (!target || !target.closest) {
      return null;
    }
    return target.closest(DONATION_APP_BUTTON_SELECTORS.join(','));
  }

  function getCurrentProductHandle() {
    var handleInput = document.querySelector('input[name="handle"]');
    if (handleInput && handleInput.value) {
      return handleInput.value;
    }
    return null;
  }

  function showDonationValidationMessage(message) {
    var modal = document.getElementById('myModal');
    var messageContainer = document.getElementById('msgMod');

    if (messageContainer) {
      messageContainer.innerHTML = message;
    }

    if (modal) {
      modal.style.display = 'block';

      // Close handler is required here because theme.min.js only sets it up
      // inside _addToCart_mg. When this modal is triggered by our file directly
      // outside the normal ATC flow, that handler may not be initialised.
      var closeButton = modal.querySelector('.close');
      if (closeButton) {
        closeButton.onclick = function () {
          modal.style.display = 'none';
        };
      }

    } else {
      alert(message.replace(/<[^>]*>/g, ''));
    }
  }

  // Attached once only — avoids stacking a new listener every time the modal opens.
  // Handles outside-click close for any modal trigger from this file.
  window.addEventListener('click', function (event) {
    var modal = document.getElementById('myModal');
    if (modal && event.target === modal) {
      modal.style.display = 'none';
    }
  });

  function validateProductHandle(handle) {
    var validationUrl = '/search?view=mg-cart-exist-vendor&q=' + encodeURIComponent(handle);

    return fetch(validationUrl)
      .then(function (response) {
        return response.json();
      });
  }

  document.addEventListener('click', function (event) {
    var button = getDonationAppButton(event.target);

    if (!button) {
      return;
    }

    // If this click was approved by a previous validation pass, let it through
    if (button.dataset.cartGuardApproved) {
      delete button.dataset.cartGuardApproved;
      return;
    }

    var productHandle = getCurrentProductHandle();

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!productHandle) {
      showDonationValidationMessage('Oops, something went wrong! Please refresh the page and try again.');
      return;
    }

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    validateProductHandle(productHandle)
      .then(function (result) {
        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (result && result.isStatus) {
          // Validation passed — mark button as approved and re-trigger click
          button.dataset.cartGuardApproved = 'true';
          button.click();
        } else {
          // Validation failed — show conflict message from server
          // Fallback guards against unexpected response shape (null, {}, missing message)
          var message = (result && result.message)
            ? result.message
            : 'Oops, something went wrong! Please refresh the page and try again.';
          showDonationValidationMessage(message);
        }
      })
      .catch(function () {
        // Fetch failed (network error etc) — fail closed, show friendly message
        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        showDonationValidationMessage('Oops, something went wrong! Please refresh the page and try again.');
      });

  }, true); // true = capture phase, runs before app button handlers

})();

/* ===== END DONATION CART VALIDATION ===== */